import { Editor } from '@tiptap/core'
import Select, { StylesConfig } from 'react-select'
import { SelectOption, SelectProps } from '../config/menu'
import { useLinkContext } from '../hooks/useLinkContext'

const MenuSelect = (props: SelectProps & { editor: Editor}) => {

    useLinkContext() // force rerender
    if (!props.getDefaultValue) {
        return <></>
    }

    const styles : StylesConfig<SelectOption> = {
        control: props.controlStyles,
        option: props.optionStyles
    }

    const value = props.getDefaultValue(props.editor)

    return <div className={`${props.id} select`}><Select 
        placeholder={props.name}
        styles={styles}
        value={value || null}
        options={ props.values }
        onChange={ (value) => { props.onChange && props.onChange(props.editor, value) } }
    /></div>       
}


export default MenuSelect; 